import type { Language } from '@apiTypes';
import { SuggestionType, useSuggestProductsQueryAPI } from '@apiTypes';
import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import useBrands from '../../brand/queries/useBrands';

const useSuggestBrands = ({
    search,
    skip,
}: {
    search: string;
    skip?: boolean;
}) => {
    const { store, language } = useStoreAndLanguageParams();

    const { data, ...response } = useSuggestProductsQueryAPI({
        variables: {
            filters: {
                type: SuggestionType.Brand,
                search,
            },
            context: {
                storeCode: store,
                language: language as Language,
            },
            limit: 10,
        },
        skip,
    });

    const items = data?.suggestProducts.items || [];
    const slugs = items.map(({ entityId }) => entityId);
    const allBrands = useBrands();
    const brands = allBrands.brands.filter(({ slug }) => slugs.includes(slug));

    return {
        brands,
        ...response,
    };
};

export default useSuggestBrands;
